/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { borderTitle } from '../icons/borders';

import Title from './Title';
import Borders from './Borders';
import Blocks from '../blocks/Blocks';

import { getDarkBackground, getDarkBorder, removeHex } from '../../lib/utils';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/partials/notebook.scss';

const propTypes = {
    page: AppPropTypes.page.isRequired,
    sections: PropTypes.arrayOf(AppPropTypes.blocks),
    color: AppPropTypes.color.isRequired,
};

const defaultProps = {
    sections: [],
};

const EventNotebook = ({ page, sections, color }) => {
    const Border = borderTitle.large;
    const backgroundPath = getDarkBackground(removeHex(color));
    const borderPath = getDarkBorder(removeHex(color));
    const colorByTheme = '#ffffff';
    return (
        <div className={styles.container}>
            <div className={styles.borderTop} style={{ backgroundImage: borderPath }} />
            <div
                className={styles.background}
                style={{ backgroundImage: backgroundPath, color: colorByTheme }}
            >
                <div className={styles.inner}>
                    <div className={styles.content}>
                        <div className={styles.border} />
                        <Borders
                            seed={page.id + 1}
                            color={color}
                            borders={{
                                top: false,
                                right: true,
                                bottom: true,
                                left: true,
                            }}
                        >
                            <div className={styles.titleContainer}>
                                <Title text={{ id: 'content.notebook' }} format="normal" />
                                <Border className={styles.underline} />
                            </div>
                            {sections.map((blocks, i) => (
                                <Blocks
                                    key={`section-${i + 1}`}
                                    blocks={blocks}
                                    className={styles.blocks}
                                />
                            ))}
                        </Borders>
                    </div>
                </div>
            </div>
        </div>
    );
};

EventNotebook.propTypes = propTypes;
EventNotebook.defaultProps = defaultProps;

const WithStateContainer = connect(({ site: { color } }) => ({
    color,
}))(EventNotebook);

export default WithStateContainer;
